import { createBrowserHistory } from 'history';

let osParam = '';
if (window.location.host.includes('zoominfo.com')) {
  const os = sessionStorage.getItem('os');
  if (
    (os === 'sales' && !window.location.href.includes('mos')) ||
    window.location.href.includes('sos')
  ) {
    osParam = '/sos';
  } else if (
    (os === 'marketing' && !window.location.href.includes('sos')) ||
    window.location.href.includes('mos')
  ) {
    osParam = '/mos';
  }
}
const history = createBrowserHistory({
  basename: osParam,
});
export default history;
